// extracted by mini-css-extract-plugin
module.exports = {"dialogs":"Dialogs_dialogs__1S21S","dialogsList":"Dialogs_dialogsList__1YeBm","DialogsHeader":"Dialogs_DialogsHeader__2WNM5","messages":"Dialogs_messages__dqca3"};